import { UsageExplorerFeatureFlagsResponse } from "@shared/types/localTypes/usage-explorer.ts";

export default async (): Promise<UsageExplorerFeatureFlagsResponse> => ({
  feature_flags: [],
});
